import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import type { McpConnection } from "@common/schemas/domains/mcp/mcp-connection.schema";
import { ConnectionActionsCell } from "./cells/ConnectionActionsCell";
import { ConnectionDateCell } from "./cells/ConnectionDateCell";
import { ConnectionPermissionsCell } from "./cells/ConnectionPermissionsCell";
import { ConnectionStatusCell } from "./cells/ConnectionStatusCell";
import { ConnectionTargetCell } from "./cells/ConnectionTargetCell";

export enum McpConnectionColumn {
    TARGET = "grantTarget",
    PERMISSIONS = "scopes",
    STATUS = "revokedAt",
    CONNECTED = "createdAt",
    LAST_USED = "lastUsedAt",
    ACTIONS = "actions",
}

export type McpConnectionRow = McpConnection;

export const mcpConnectionsViewConfig: ViewConfig<
    McpConnectionRow,
    McpConnectionColumn,
    never
> = {
    columns: {
        [McpConnectionColumn.TARGET]: {
            accessorKey: "grantTarget",
            name: "Workspace access",
            header: "Workspace access",
            cell: ConnectionTargetCell,
            minSize: 180,
            maxSize: 260,
        },
        [McpConnectionColumn.PERMISSIONS]: {
            accessorKey: "scopes",
            name: "Permissions",
            header: "Permissions",
            cell: ConnectionPermissionsCell,
            minSize: 130,
            maxSize: 180,
        },
        [McpConnectionColumn.STATUS]: {
            accessorKey: "revokedAt",
            name: "Status",
            header: "Status",
            cell: ConnectionStatusCell,
            minSize: 100,
            maxSize: 140,
        },
        [McpConnectionColumn.CONNECTED]: {
            accessorKey: "createdAt",
            name: "Connected",
            header: "Connected",
            cell: ConnectionDateCell,
            ...DATE_COLUMN_SIZE,
        },
        [McpConnectionColumn.LAST_USED]: {
            accessorKey: "lastUsedAt",
            name: "Last used",
            header: "Last used",
            cell: ConnectionDateCell,
            ...DATE_COLUMN_SIZE,
        },
        [McpConnectionColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ConnectionActionsCell,
            minSize: 90,
            maxSize: 90,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
